module.exports = __webpack_public_path__ + "static/gym-98a3ba16aeddede98980eaa918c705db.jpg";